<div class="p-3" *ngIf="report">
  <div class="row mt-3">
    <div
      class="col-12 center p-4"
      *ngIf="
        report.incidences && report.incidences.length == 0;
        else existingIncidence
      "
    >
      <p>No hay un tipo de incidencia activa</p>
    </div>
    <ng-template #existingIncidence>
      <div class="col-12">
        <app-incidence-card
          [incidence]="selectedIncidence"
        ></app-incidence-card>
      </div>
      <div class="col-12 center">
        <button
          class="btn mt-2 mx-1"
          [class]="
            selectedIncidence.id == button.id
              ? 'btn-primary'
              : 'btn-outline-primary'
          "
          (click)="selectIncidence(button, i)"
          *ngFor="let button of report.incidences; let i = index"
        ></button>
      </div>
    </ng-template>

    <div class="col-12 mt-4">
      <div class="row">
        <div class="col-12 center mt-3" *ngIf="report.images.length == 0">
          <p>No hay imágenes disponibles</p>
        </div>
        <div
          class="col-12 center flex-column"
          *ngIf="report.images.length === 1"
        >
          <div>
            <img
              class="pos-image"
              [src]="report.images[0].image"
              (click)="openImageViewer(report.images[0].image)"
              width="250"
            />
          </div>
          <small class="text-center">hacer click para expander</small>
        </div>
        <div class="col-lg-12 col-sm-6 text-center">
          <div class="carousel" *ngIf="report.images.length > 1">
            <owl-carousel-o [options]="customOptions">
              <ng-container *ngFor="let image of report.images; let i = index">
                <ng-template carouselSlide [id]="i">
                  <img
                    class="pos-image"
                    [src]="image.image"
                    (click)="openImageViewer(image.image)"
                    alt=""
                  />
                </ng-template>
              </ng-container>
            </owl-carousel-o>
            <small>hacer click para expander</small>
          </div>
        </div>
        <!-- Multimedia -->
        <div class="col-lg-12" *ngIf="report.videos.length > 0">
          <h3 class="p-3">Video</h3>
          <div *ngFor="let item of report.videos">
            <video
              controls
              [src]="item.video"
              type="video/ogg;"
              codecs=" mp4v.20.8, samr"
               style="width: 100%;"
            >
              Tu navegador no admite el elemento <code>video</code>.
            </video>
          </div>
        </div>
        <div class="col-lg-12" *ngIf="report.audios.length > 0">
          <h3 class="p-3">Audio</h3>
          <div *ngFor="let item of report.audios">
            <video
              [src]="item.audio"
              type="video/ogg;"
              codecs=" mp4v.20.8, samr"
              controls
              style="width: 100%;"
            >
              Tu navegador no admite el elemento <code>video</code>.
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #ImageViewer>
  <div class="modal-header p-0">
    <div class="brand-logo" style="font-size: 20px; padding: 8px">
      <img
        class="img-fluid"
        src="assets/img/logo.png"
        alt="App Logo"
        style="height: 54px"
      />
      Imágen
    </div>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="globalFunction.Modal(ImageViewer, 'hide', '')"
      style="font-size: 34px; padding: 23px"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div
    class="modal-body d-flex flex-column lign-items-center justify-content-center"
  >
    <app-image-viewer [imageURL]="selectedImage"> </app-image-viewer>
  </div>
</ng-template>
